import React, { Component } from 'react'
import styles from '../../styles/common/stepsMenu.module.css'

export class StepsMenu extends Component {
    onStepClick(stepId) {
        const { featureId } = this.props;
        this.props.selectStep({stepId, featureId})
        this.props.scrollIntoStep(stepId)
    }

    renderStep(step) {
        const { selection } = this.props;
        return (
            <div 
                className={selection === step.id ? styles.selectedItem : styles.item} 
                onClick={() => this.onStepClick(step.id)}
            >
            {step.title}
            </div>
        );
    }

    render() {
        return ( 
            <div className={styles.mainContainer}>
                <div className={styles.container}>
                    {this.props.steps.map(step => {return this.renderStep(step)})}
                </div>

                <div className={styles.github} onClick={() => window.location.href="https://www.github.com/moneris/"}>
                    <h5><i className="fa fa-github" style={{marginRight: '10px', fontSize: '1rem'}}></i>GITHUB</h5>
                </div>
            </div>
        )
    }
}

export default StepsMenu
